import React from 'react'

//@ts-ignore
import { Media } from 'reactstrap'
import { Message, StyledCard, StyledMoment, Title } from './styles'
import { NewDot } from '../../../styles/common'
import { staticAssetsPath } from '../../../configs/constants'
import { useNavigate } from 'react-router-dom'
//@ts-ignore
import { Avatar } from 'dsm-react-lib'
import { useSasToken } from '../../../_hooks/useSasToken'
import { useThemeManager } from '../../../_hooks/useThemeManager'

export const Notification: React.FC<any> = ({ item, icon, toggle }: any) => {
  const navigate = useNavigate()
  const { appendToken } = useSasToken()
  const { isDarkTheme } = useThemeManager()
  const CentraliIcon = appendToken(
    `${staticAssetsPath}/images/logo/${isDarkTheme ? 'Centrali-Icon-dark' : 'Centrali-Icon'}.svg`
  )
  const createdAt = item.createdAt ? `${item.createdAt}` : item.CreatedAt
  const appIcon = icon ? appendToken(icon) : CentraliIcon

  return (
    <StyledCard className="border m-1 bg-surface p-2">
      {/* <Media left>{!item.seen && <NewDot />}</Media> */}
      <Media body className="d-flex flex-column">
        <div className="d-flex justify-content-between align-items-center mb-1">
          <div className="d-flex align-items-center">
            {!item.seen && <NewDot />}
            <Avatar content={appIcon} size="30px" shape="rounded" alt="logo" className="m-0" />
            <Title>{item.title}</Title>
          </div>
          <StyledMoment fromNow>
            {new Date(createdAt.includes('Z') ? createdAt : `${createdAt}Z`).getTime()}
          </StyledMoment>
        </div>
        <Message className="notification-text">{item.message}</Message>
        {item?.ctaLinks &&
          (item?.ctaLinks?.includes(window.location.origin) ? (
            <div
              className="mt-1 btn btn-primary align-self-end"
              color="primary"
              data-testid="ctaLink"
              onClick={() => {
                navigate(item?.ctaLinks?.replace(window.location.origin, ''))
                toggle()
              }}>
              {item.ctaText}
            </div>
          ) : (
            <a
              className="mt-1 btn btn-primary align-self-end"
              color="primary"
              href={item.ctaLinks}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="ctaLink">
              {item.ctaText}
            </a>
          ))}
      </Media>
      <Media right></Media>
    </StyledCard>
  )
}
